import React from 'react';
import * as styles from './index.module.less';
import { SECURITY_LOGOS } from '@/constants/layout';

const SecurityPart = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.logo_container}>
        {SECURITY_LOGOS.map((item, index) => {
          return <img key={index} src={item.src} alt={item.alt} className={styles.logo_self} />;
        })}
      </div>
    </div>
  );
};
export default SecurityPart;
